import { BalanceFetchAccount } from '@features/accounts/types';
import { BalanceFetchSavings } from '@features/accounts/types/balance-fetch-savings';
import { api } from '@src/lib/api-client';
import { AxiosResponse } from 'axios';

export type GetBalanceFetchesResponse = {
  accounts: BalanceFetchAccount[];
  savings?: BalanceFetchSavings;
  status: string;
};

export type GetBalanceFetchesProps = {
  accountId: string;
  jobId: string;
};

export async function getBalanceFetches({
  accountId,
  jobId,
}: GetBalanceFetchesProps): Promise<GetBalanceFetchesResponse> {
  return await api
    .get(`/api/v3/user/accounts/${accountId}/balance-fetches/${jobId}`)
    .then((res: AxiosResponse<GetBalanceFetchesResponse>) => res.data);
}
